export default __webpack_public_path__ + "static/image_restauration_s@2x-c1befe11eb71be7caa74ab513f8d6c14.jpg";